module.exports = __webpack_public_path__ + "fonts/righthand-bolditalicdash-personal.e7a59827.ttf";